module.exports = __webpack_public_path__ + "img/Carica_papaya.3c7fcfca.jpg";